import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { LoadingOutlined } from '@ant-design/icons'
import qs from 'query-string'
import { message, Modal } from 'antd'
import { appendQuery, getLocalhostDeviceId, loginRedirectUrl } from 'utils'
import { getApplication, validHost } from 'utils'
import { Uuid } from '@sisyphe/utils'

// 重置sessionStorage地址
const resetSessionStorage = search => {
  const { code, state, applicationCode, back_url } = qs.parse(search)
  if (back_url) {
    const oauthSearch = { code, state, applicationCode }
    window.sessionStorage.setItem('search', `?${qs.stringify(oauthSearch)}`)
  }
}

const Oauth = () => {
  const [valid, setValid] = React.useState(true)
  const { search } = useLocation()
  const dispatch = useDispatch()
  debugger
  useEffect(() => {
    ;(async function () {
      const { code, state: stateString } = qs.parse(search)

      // 重新设置置需要参数，排除不需要的参数
      resetSessionStorage(search)

      console.log('auth received state:', stateString)

      if (code) {
        // 因为某写历史原因，state 既支持 qs 序列化，又支持 json 序列化
        let state = {}
        try {
          state = JSON.parse(decodeURIComponent(stateString || '{}'))
        } catch (error) {
          state = qs.parse(decodeURIComponent(stateString || ''))
        }
        console.log('after JSON.parse/qs.parse state:', state)

        // type: 登录成功后的分发方式
        //   code_redirect: 不处理 code, 直接将 code 作为参数跳转到目标 url
        //   redirect: 调用登录接口，将 code 转换为登录会话后作为参数跳转到目标 url
        //   post_message: 调用登录接口，将 code 转换为登录会话后通过 post message 或 console message 传递给调用者
        // back_url: 登录成功后的跳转 url，仅当 type 为 code_redirect 或 redirect 生效
        // payload: 使用 code 登录时所需的额外参数
        const { back_url, type, payload } = state

        console.log('type', type)

        // 处理方式1：直接将 code 返回给发起方自行创建会话
        if (type === 'code_redirect') {
          window.location.href = appendQuery(back_url, { code })
        } else if (type === 'code_console') {
          const params = {
            data: code,
            action: 'code_console',
          }
          console.log('postMessage', code)
          window.parent.postMessage({ type: 'code_console', code }, '*')
          console.log(JSON.stringify(params))
        } else {
          const result = await dispatch({
            type: 'login/qyWeChatLogin',
            payload: {
              wxCode: code,
              returnUrl: loginRedirectUrl(back_url),
              applicationCode: getApplication(),
              ...payload,
              workId: state?.workId,
              deviceId: getLocalhostDeviceId(),
            },
          })

          if (result) {
            // 301 跳转
            if (result.code === '301') {
              // 是否需要信任设备
              if (result.data.unTrustDevice) {
                try {
                  const deviceId = await new Promise((resolve, reject) => {
                    Modal.confirm({
                      title:
                        '系统提示当前登录设备是陌生设备，请确认是否信任此设备？确定后将不再提醒',
                      type: 'warning',
                      okText: '确定',
                      cancelText: '取消',
                      onOk() {
                        resolve(getLocalhostDeviceId())
                      },
                      onCancel: () => {
                        reject()
                      },
                    })
                  })
                  // 调用信任设备接口
                  dispatch({
                    type: 'login/addTrustDevice',
                    payload: {
                      deviceId: deviceId, // 设备ID
                      workId: result.data.workId, // 工号
                    },
                  })
                } catch (err) {}
              }
              window.location.href = result.data.redirectUrl
            } else if (result.code !== '103') {
              message.error(result.message).then(() => {
                window.history.go(-1)
              })
            }
          }
        }
      }
    })()
  }, [search, dispatch])

  return (
    <div style={{ paddingTop: 100, textAlign: 'center' }}>
      {valid ? <LoadingOutlined></LoadingOutlined> : '非法来源'}
    </div>
  )
}

export default Oauth
